__webpack_require__.p = "https://product-details.core-artifacts.com/static/";